import styled from 'styled-components';
import { colors, fontWeight } from '@grnhse/seedling/lib/azalea/constants';

export const Header = styled.div`
  ${fontWeight('normal')};
  color: ${colors.darkGrey};
  font-size: 12px;
  padding-bottom: 0.5rem;
`;
